function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import Measure from "react-measure";
import Rehearse from "./Rehearse";

var Teleprompter = function (_React$Component) {
  _inherits(Teleprompter, _React$Component);

  function Teleprompter(props) {
    _classCallCheck(this, Teleprompter);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.scrollTo = function (node, position) {
      node.style.top = position + "px";
    };

    _this.handleSizeChange = function () {
      var teleprompter = _this.scrollBox.current;

      if (!_this.scrollBox.current) {
        return;
      }

      var clientView = teleprompter.getClientRects()[0];
      var paddingTop = Math.max(clientView.height - 50, 10);
      teleprompter.style.paddingTop = paddingTop + "px";
    };

    _this.isScrolling = false;
    _this.currentPos = 0;

    _this.scroll = function () {
      if (_this.animationRequestId) {
        cancelAnimationFrame(_this.animationRequestId);
      }

      var teleprompter = _this.scrollBox.current;

      if (!_this.scrollBox.current) {
        return;
      }

      var clientView = teleprompter.getClientRects()[0];
      var paddingTop = Math.max(clientView.height / 3, 10);
      _this.currentPos = teleprompter.scrollTop;
      var oldTime = performance.now();
      teleprompter.style.paddingTop = paddingTop + "px";
      teleprompter.style.top = 0;
      _this.scrollHeight = teleprompter.scrollHeight;

      var update = function update(newTime) {
        if (_this.unmounted) {
          return;
        }

        var delta = newTime - oldTime;
        var _this$props = _this.props,
            isScrolling = _this$props.isScrolling,
            speed = _this$props.speed,
            onScrollEnd = _this$props.onScrollEnd;
        oldTime = newTime;

        if (!isScrolling) {
          _this.animationRequestId = requestAnimationFrame(update);
          return;
        }

        _this.currentPos -= delta * 0.025 * (speed > 1 ? (speed - 1) * 1.5 : 1);

        _this.scrollTo(teleprompter, _this.currentPos);

        if (Math.abs(_this.currentPos) > _this.scrollHeight - 150) {
          console.log("scroll end");

          if (onScrollEnd) {
            onScrollEnd();
          }

          return;
        }

        _this.animationRequestId = requestAnimationFrame(update);
      };

      _this.animationRequestId = requestAnimationFrame(update);
    };

    _this.scrollBox = React.createRef();
    return _this;
  }

  Teleprompter.prototype.componentDidMount = function componentDidMount() {
    setTimeout(this.scroll);
  };

  Teleprompter.prototype.componentDidUpdate = function componentDidUpdate() {
    var isScrolling = this.props.isScrolling;

    if (this.isScrolling !== isScrolling) {
      this.isScrolling = isScrolling;
      this.currentPos = 0;
      this.scrollTo(this.scrollBox.current, 0);
      this.scrollHeight = this.scrollBox.current.scrollHeight;
      setTimeout(this.scroll);
    }
  };

  Teleprompter.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;
  };

  Teleprompter.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        script = _props.script,
        fontSize = _props.fontSize,
        fontColor = _props.fontColor,
        onRehearse = _props.onRehearse,
        isScrolling = _props.isScrolling;
    return React.createElement("div", {
      className: "recorder__script recorder__script--no-video"
    }, React.createElement("div", {
      className: "recorder__script-wrapper"
    }, React.createElement("div", {
      className: "recorder__script-holder"
    }, React.createElement(Measure, {
      bounds: true,
      onResize: function onResize() {
        return _this2.handleSizeChange();
      },
      innerRef: function innerRef(node) {
        _this2.spacer = node;
      }
    }, function (_ref) {
      var measureRef = _ref.measureRef;
      return React.createElement("div", {
        style: {
          width: "100%",
          height: "100%"
        },
        ref: measureRef
      });
    }), React.createElement("div", {
      ref: this.scrollBox,
      className: "recorder__script-text",
      style: {
        color: fontColor,
        fontSize: fontSize,
        textShadow: "2px 2px 2px " + fontColor
      }
    }, script)), onRehearse && !isScrolling && React.createElement(Rehearse, {
      onStart: onRehearse
    })));
  };

  return Teleprompter;
}(React.Component);

Teleprompter.propTypes = process.env.NODE_ENV !== "production" ? {
  script: PropTypes.string.isRequired,
  isScrolling: PropTypes.bool,
  fontSize: PropTypes.number.isRequired,
  speed: PropTypes.number.isRequired,
  onRehearse: PropTypes.func,
  onScrollEnd: PropTypes.func
} : {};
Teleprompter.defaultProps = {
  isScrolling: false
};
export default Teleprompter;